import React, { useCallback, useContext, useEffect, useState } from 'react';

import { SearchHelper } from './search.helper';
import FormSelect from '../FormSelect';
import MobileDetect from 'mobile-detect';
import { OptionCountries, OptionPhones } from './constant';

type TOption = {
  value: string;
  label: string;
  extra: string;
};

const md = new MobileDetect(window.navigator.userAgent);
const os = md.os();
const isMobile = os === 'AndroidOS' || os === 'iOS';

const FormSelectCountry = ({ showCallingCode = true, onUserSelect, ...rest }: any) => {
  return (
    <FormSelect<TOption>
      {...rest}
      //className={classNames(rest.className, css.container)}
      onChange={(v) => {
        onUserSelect?.(v);
        rest.onChange(v);
      }}
      isSearchable={true}
      placeholder={''}
      options={showCallingCode ? OptionPhones : OptionCountries}
      filterOption={SearchHelper.filterOption}
    />
  );
};

export default FormSelectCountry;
